import history from "./history";

export default class Auth {
  handleAuth = jwtResp => {
    sessionStorage.setItem("access_token", jwtResp.accessToken);
    sessionStorage.setItem("firstName", jwtResp.firstName);
    sessionStorage.setItem("lastName", jwtResp.lastName);
    sessionStorage.setItem("refresh_token", jwtResp.refreshToken);
    sessionStorage.setItem("roles", JSON.stringify(jwtResp.roles));
    sessionStorage.setItem("passwordExpired", jwtResp.passwordExpired);
    sessionStorage.setItem("id",jwtResp.id);
    return {firstName: jwtResp.firstName,
    lastName: jwtResp.lastName,
    accessToken: jwtResp.accessToken,
    refreshToken: jwtResp.refreshToken,
    roles: jwtResp.roles,
    passwordExpired: jwtResp.passwordExpired,
    id:jwtResp.id};
  };

  getAccessToken = () => {
    if (sessionStorage.getItem("access_token")) {
      const accessToken = sessionStorage.getItem("access_token");
      return accessToken;
    } else {
      return "";
    }
  };

  getProfile = () => {
    let accessToken = sessionStorage.getItem("access_token");
    if (!accessToken){
      return null;
    }
    let firstName = sessionStorage.getItem("firstName");
    let lastName = sessionStorage.getItem("lastName");
    let refreshToken = sessionStorage.getItem("refresh_token");
    let roles = sessionStorage.getItem("roles");
    let userId = sessionStorage.getItem("id");
    return {firstName: firstName,
    lastName: lastName,
    accessToken: accessToken,
    refreshToken: refreshToken,
    roles: roles,
    userId: userId};
  };

  getRoles = () => {
    if (sessionStorage.getItem("roles")) {
      const roles = JSON.parse(sessionStorage.getItem("roles"));
      return roles;
    } else {
      return null;
    }
  };

  logout = () => {
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("firstName");
    sessionStorage.removeItem("lastName");
    sessionStorage.removeItem("refresh_token");
    sessionStorage.removeItem("roles");
    sessionStorage.removeItem("business_id");
    setTimeout(() => {
      history.replace("/ui/login");
    }, 200);
  };

  isAuthenticated = () => {
    if (sessionStorage.getItem("access_token")) {
      return true;
    } else {
      return false;
    }
  };

  getRefreshToken = () => {
     return sessionStorage.getItem("refresh_token");
  }

  updateTokens = (jwtToken) => {
    sessionStorage.setItem("access_token", jwtToken.accessToken);
    sessionStorage.setItem("refresh_token", jwtToken.refreshToken);
    return {
      firstName: sessionStorage.getItem("first_name"),
      lastName: sessionStorage.getItem("last_name"),
      accessToken: jwtToken.accessToken,
      refreshToken: jwtToken.refreshToken,
      roles: JSON.parse(sessionStorage.getItem("roles"))
    };
  }
}
